module.exports = __webpack_public_path__ + "static/img/pic_3.5eb8291.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quiz/pic_3.png
// module id = JO4L
// module chunks = 37